import React, { useState, useEffect } from "react";
import Sidebar from "../Common/Sidebar";
import { Button } from "primereact/button";
import axios from "axios";
import CommonValues from "../Common/utils";
import removebookmark from "../assets/images/removebookmark.svg";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";

interface Bookmark {
  id: number;
  userId: number;
  companyId: number;
  conversationId: number | null;
  bookmarkedTime: string;
  title: string;
}

interface Conversation {
  id: number;
  question: string;
  answer: string;
}

interface BookmarkedChat extends Bookmark {
  conversation: Conversation | null;
}

export default function SavedChats() {
  const categories = ["Sales", "Marketing", "Insurance", "Tax"];
  const [activeCategory, setActiveCategory] = useState("Sales");
  const [bookmarkedChats, setBookmarkedChats] = useState<BookmarkedChat[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingConversationId, setLoadingConversationId] = useState<
    number | null
  >(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [conversationIdToDelete, setconversationIdToDelete] = useState<number | null>(null);

  useEffect(() => {
    fetchBookmarkedChats();
  }, []);

  const fetchConversationDetails = async (
    conversationId: number
  ): Promise<Conversation | null> => {
    try {
      if (isLoading) return null;
      const token = CommonValues.GetToken();
      const response = await axios.get(
        `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/conversation/${conversationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error : any) {
      if (error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);}
      console.error("Error fetching conversation details:", error);
      return null;
    }
  };

  const fetchBookmarkedChats = async () => {
    try {
      const token = CommonValues.GetToken();
      const response = await axios.get(
        `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/bookmark/GetbyUserId`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (Array.isArray(response.data)) {
        const processedChats = await Promise.all(
          response.data.map(async (bookmark: Bookmark) => {
            let conversation = null;
            if (bookmark.conversationId) {
              conversation = await fetchConversationDetails(
                bookmark.conversationId
              );
            }
            const processedChat = {
              ...bookmark,
              conversation,
            };
            return processedChat;
          })
        );
        setBookmarkedChats(processedChats);
      } else {
        console.error("Invalid response format:", response.data);
        setError("Invalid response format from server");
      }
    } catch (error: any) {
      if (error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);}
      console.error("Error fetching bookmarked chats:", error);
      setError("Failed to fetch bookmarked chats");
    } finally {
      setIsLoading(false);
    }
  };
const openDeleteDialog = (conversationId :any) => {
  setconversationIdToDelete(conversationId);
  setDeleteDialogVisible(true);
};
const confirmDelete = async () => {
  if (conversationIdToDelete !== null) {
    await removeBookmark(conversationIdToDelete);
  }
  setDeleteDialogVisible(false);
  setconversationIdToDelete(null);
};
const cancelDelete = () => {
  setDeleteDialogVisible(false);
  setconversationIdToDelete(null);
};
const removeBookmark = async (conversationId: number | null) => {
  if (conversationId === null) return;
  setLoadingConversationId(conversationId); 
  try {
    const token = CommonValues.GetToken();
    await axios.delete(
      `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/Removebookmark/${conversationId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }
    );
    setTimeout(() => {
      setBookmarkedChats((prev) =>
        prev.filter((chat) => chat.conversationId !== conversationId)
      );
      setLoadingConversationId(null); 
    }, 1500); 
  } catch (error : any) {
    if (error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);}
    console.error("Failed to remove bookmark:", error);
    setLoadingConversationId(null);
  }
};

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      let day = "";
      if (date.toDateString() === today.toDateString()) {
        day = "Today";
      } else if (date.toDateString() === yesterday.toDateString()) {
        day = "Yesterday";
      } else {
        day = date.toLocaleDateString("en-US", { weekday: "long" });
      }

      return {
        date: date.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        }),
        day,
        time: date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      };
    } catch (error) {
      console.error("Error formatting date:", error);
      return {
        date: "Invalid date",
        day: "",
        time: "",
      };
    }
  };
  const [showWideSidebar, setShowWideSidebar] = useState(true);

  const onSidebarValueChanged = (value: any) => {
    setShowWideSidebar(value);
  };
  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename="savedchats"
        onSidebarValueChanged={onSidebarValueChanged}
      />

      <div className="flex-grow-1 d-flex flex-column bg-light py-3 px-2 mt-4 ">
        <div
          className={` ${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
          <div>
            <h2 className="fw-bold">Bookmarks</h2>
            <p className="text-muted">
              Welcome back! Here you can continue with your saved chats
            </p>
          </div>
          {/* <div className="d-flex gap-2 my-3 flex-wrap">
            {categories.map((cat, idx) => (
              <Button
                key={idx}
                onClick={() => setActiveCategory(cat)}
                className={`alexandria-btn ${
                  activeCategory === cat
                    ? "primary-btn "
                    : "primary-inactive-btn"
                }`}
              >
                {cat}
              </Button>
            ))}
          </div> */}
          <div className="row mt-2 g-3 text-14">
            {isLoading ? (
              <div className="col-12 text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <div className="col-12 text-center text-danger">{error}</div>
            ) : bookmarkedChats.length === 0 ? (
              <div className="col-12 text-center text-muted">
                No bookmarked chats found
              </div>
            ) : (
              bookmarkedChats.map((chat, idx) => {
                const { date, day, time } = formatDate(chat.bookmarkedTime);
                return (
                <div className="col-12" key={chat.id}>
                  <div className="card chat-card rounded-4 shadow-sm border-0 mb-2"
                       onClick={() => navigate(`/chat/${chat.conversationId}`)}>
                     <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                               <h6 className="card-title mb-0 " style={{color:"#3D3A3A"}}>
                                    {chat.title ||
                                     (chat.conversation
                                     ? chat.conversation.question
                                     : "Conversation not available")}
                              </h6>
                            </div>
                           <button
                               className="btn p-0 border-0 bg-transparent btn bg-transparent unbookmark"
                              onClick={(e) => {e.stopPropagation(); openDeleteDialog(chat.conversationId);}}
                               disabled={loadingConversationId === chat.conversationId}
                               title="Remove bookmark"
                           >
                             {loadingConversationId === chat.conversationId ? (
                              <div
                                 className="spinner-border spinner-border-sm text-secondary"
                                 style={{ width: 20, height: 20 }}
                                 role="status">
                             </div>
                            ) : (
                             <img
                                src={removebookmark}
                                alt="Remove Bookmark"
                                width={20}
                                style={{
                                filter: "invert(21%) saturate(7497%) brightness(97%) contrast(118%)", }}
                              />
                            )}
                         </button>
                       </div>
                         <div className="mt-3 d-flex justify-content-between text-muted small">
                           <span>{date}, {day} {time}</span>
                           <span>Bookmark ID: {chat.id}</span>
                        </div>
                      </div>
                    </div>
                 </div>
                );
              })
            )}
          </div>
        </div>
      </div> 
      <Dialog
         header="Confirm Delete"
         visible={deleteDialogVisible}
         style={{ width: '350px' }}
         modal
         onHide={cancelDelete}
         className="styled-dialog"
         footer={
            <div className="d-flex justify-content-center">
               <Button label="Cancel" icon="pi pi-times" onClick={cancelDelete}  className="alexandria-btn secondary-btn me-4" />
               <Button label="Delete" icon="pi pi-trash" onClick={confirmDelete} className="p-button curved-button primary-btn" />
            </div>
           }>
         <p> Are you sure you want to delete this <strong>Bookmark</strong>?</p>
     </Dialog>
    </div>
  );
}
